import React, { FunctionComponent } from "react";
import { ICardElementWithChildren } from "backend/model/model";
import TextElement from "reportengine/TextElement";
import Text from "reportengine/Text";
import Slide from "reportengine/Slide";
import DomElement from "reportengine/DomElement";
import Portion from "reportengine/Portion";
import SlideTable from "reportengine/SlideTable";
import SlideTableRow from "reportengine/SlideTableRow";
import ProgressBar from "design/components/progress/ProgressBar";
import PercentageBar from "design/components/progress/PercentageBar";
import { changeColorBrightness } from "@qpr/client-api-base/utils/color";

const InitiativePerformanceTable = (
  props: React.PropsWithChildren<{
    items: ICardElementWithChildren[];
    report: ICardElementWithChildren;
  }>
) => {
  const { items } = props;
  //   const lastPeriod = useYearsLastPeriod(item.period?.name || "");

  return (
    <>
      <Slide index={8}>
        <TextElement slideElement="title">
          Initiative Performance Summary
        </TextElement>
        <TextElement slideElement="period">
          {props.report.period?.name || ""}
        </TextElement>
        <TextElement slideElement="footer">
          {items?.[0]?.scorecardname || "Performance Report"}
        </TextElement>

        <Text slideElement="total_cnt">
          <Portion paragraphIndex={0} portionIndex={0}>
            {items.length}&nbsp;
          </Portion>
        </Text>
        <SlideTable slideElement="initiative_performance_table">
          {items.map((item) => {
            const darker = changeColorBrightness(`#${item.rangecolor}`, 0.72);

            return (
              <SlideTableRow>
                <TextElement slideElement="">{item.name}</TextElement>
                <DomElement slideElement="" typename="image" selector=".item">
                  <div
                    className="item"
                    style={{ width: "120px", height: "40px" }}
                  >
                    <PercentageBar
                      color={`#${item.rangecolor}`}
                      value={Number(item.COMPLETION_PERCENTAGE)}
                    />
                  </div>
                </DomElement>
                <TextElement slideElement="">
                  {item.PLANNED_COMPLETION_prettyvalue}
                </TextElement>
                <DomElement slideElement="" typename="image" selector=".item">
                  {item.VARIANCE ? (
                    <div
                      className="item"
                      style={{
                        width: "120px",
                        padding: "10px",
                        background: `linear-gradient(#${item.rangecolor}22, #${item.rangecolor}55)`,
                        borderRadius: "20px",
                        fontSize: "18px",
                        color: darker,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {item.VARIANCE_prettyvalue}
                    </div>
                  ) : (
                    <div className="item">0%</div>
                  )}
                </DomElement>
              </SlideTableRow>
            );
          })}
        </SlideTable>
      </Slide>
    </>
  );
};

export default InitiativePerformanceTable;
